import { windowUnloadEvent } from "./helpers/browsers"

window.flash = function(message, type, seconds) {
    window.events.$emit('flash', message, type, seconds)
}

window.isLoading = function() {
    window.events.$emit('isLoading')
}

window.stopLoading = function() {
    window.events.$emit('stopLoading')
}

window.onpopstate = function () {
    location.reload()
};

windowUnloadEvent()